import React, { useState } from "react";
import { Card, Typography, Button } from "antd";
import toast from "react-hot-toast";
import subscriptionService from "../services/subscriptionService";

const { Title, Text } = Typography;

const Pricing = () => {
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async () => {
    try {
      setLoading(true);
      const authData = JSON.parse(localStorage.getItem("authData") || "{}");
      const token = authData?.token;
      if (!token) {
        toast.error("Please login first.");
        return;
      }

      const response = await subscriptionService.createCheckoutSession(token);
      if (!response?.checkoutUrl) {
        toast.error("Unable to start checkout right now.");
        return;
      }

      window.location.assign(response.checkoutUrl);
    } catch (error) {
      toast.error(error.response?.data?.error || "Failed to start checkout.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <Card className="w-full max-w-xl rounded-2xl shadow-md">
        <Title level={3} className="!text-[#1c5a85] !mb-2">
          Premium Membership
        </Title>
        <Text className="block text-gray-600 mb-6">
          Subscribe to unlock all premium features.
        </Text>

        <div className="border border-[#e8f1f7] rounded-xl p-6 mb-6">
          <Title level={4} className="!mb-1">
            $10 / month
          </Title>
          <Text className="text-gray-500">Billed monthly, cancel anytime.</Text>
        </div>

        <Button
          type="primary"
          size="large"
          className="w-full bg-[#1e5782] hover:bg-[#184766]"
          onClick={handleSubscribe}
          loading={loading}
        >
          Subscribe Now
        </Button>
      </Card>
    </div>
  );
};

export default Pricing;
